const v17 = (state: any) => {
  return {
    ...state,
    options: {
      ...state.options,
      tableViews: {
        ...state.options.tableViews,
        freelancersTable: {
          "Order Nr.": true,
          "Name Surname": true,
          Status: true,
          Category: true,
          "Employment Type": true,
          Project: true,
          "Start Date": true,
          "End Date": true,
          "Contract Type": true,
          "Trial End Date": true,
          "Office / Work Space": true,
          "Work Format": true,
          "Wage Change": true,
          Bonuses: true,
          Benefits: true,
          "Accident Insurance": true,
          ORGANIMI: true,
          "Work Email": true,
          "Personal Code": true,
          "Birthday Date": true,
          "Phone Number": true,
          "Personal Email": true,
          Address: true,
          Creator: true,
          Comments: true,
        },
      },
    },
  };
};

export default v17;
